/**
 * Factory for creating LoginService instances based on platform
 */

import { container } from 'tsyringe';
import LoginServiceNative from './LoginServiceNative';
import LoginServiceWeb from './LoginServiceWeb';
import ILoginService from './ILoginService';

/**
 * Parameters for creating LoginService strategies
 */
export interface ILoginServiceFactoryParams {
  isNative: boolean;
}

/**
 * Factory Pattern to encapsulate LoginService creation logic
 */
export class LoginServiceFactory {
  /**
   * Creates the appropriate LoginService based on the platform
   */
  static createService(params: ILoginServiceFactoryParams): ILoginService {
    const { isNative } = params;

    if (isNative) {
      return new LoginServiceNative();
    } else {
      return new LoginServiceWeb();
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return ['LoginServiceNative', 'LoginServiceWeb'];
  }
}
